import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, ValidationErrors, NgForm, FormControl } from '@angular/forms';
import { Registration, IKvKSearchResult } from '../../interfaces';
import * as _ from 'lodash';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-kvk-search',
  templateUrl: './kvk-search.component.html',
  styleUrls: ['./kvk-search.component.less']
})
export class KvkSearchComponent {
  @Input() public question: Registration.Form.IElement;
  @Input() public formGroup: FormGroup;
  @Input() public form: NgForm;
  @Output() public caribbean = new EventEmitter<boolean>();
  @Output() public kvkSearch = new EventEmitter<IKvKSearchResult>();
  public caribianControl = new FormControl();
  public caribisch: boolean;

  public get valid(): boolean {
    return this.formGroup.controls[this.question.inputKey].valid;
  }

  public get submitted(): boolean {
    return this.form.submitted;
  }

  public get required(): boolean {
    const attr = this.getAttribute('required');
    return attr && attr === 'required';
  }

  public get placeholder(): string {
    const attr = this.getAttribute('placeholder');
    return attr || '';
  }

  public get pattern(): string {
    const attr = this.getAttribute('pattern');
    return attr || '';
  }

  constructor(private _http: HttpClient, private router: Router) {
  }

  private getAttribute(name: string): string {
    let result;
    this.question.attributes.forEach((item) => {
      if (item.name === name) {
        result = item.value;
      }
    });

    return result;
  }

  public setCaribisch() {
    let value = this.caribianControl.value as boolean;
    this.caribbean.emit(value);
    if (value) {
      this.formGroup.controls[this.question.inputKey].setValue('no value');
    } else {
      this.formGroup.controls[this.question.inputKey].setValue(null);
    }
  }

  public onKeyDown(event: KeyboardEvent) {
    if (event.keyCode === 13) {
        this.onSearch();
      event.cancelBubble = true;
      event.preventDefault();
    } 
  }

  public onSearch() {
    let value = this.caribianControl.value as boolean;
    if (value) {
      return;
    }

    const url = `/api/kvk/v1/search/${encodeURIComponent(this.question.control.value)}`;
    console.log("After url kvk");
    this._http.get<IKvKSearchResult>(url)
      .toPromise()
      .then((result) => {
        console.log(result);
        this.kvkSearch.emit(result);
      })
      .catch((reason: HttpErrorResponse) => {
        if (reason.status === 400) {
          this.kvkSearch.emit({ address: '', city: '', country: '', organisation: '', postalCode: '', errorCode: 0, errorMessage: '' });
          const err: ValidationErrors = { 'badrequest': 'BadRequest' };
          this.question.control.setErrors(err);
        } else if (reason.status === 404) {
          this.kvkSearch.emit({ address: '', city: '', country: '', organisation: '', postalCode: '', errorCode: 0, errorMessage: '' });
          const err: ValidationErrors = { 'notfound': 'NotFound' };
          this.question.control.setErrors(err);
        } else {
            console.log("ERROR:");
            console.log(reason);
          this.router.navigate(['/error-page/kvk-down']);
        }
      });
  }
}
